<script>
import { mapActions, mapState } from 'vuex';
import ItineraryPricesWrapper from '../../components/itinerary/itineraryPrices/ItineraryPricesWrapper';

export default {
  name: 'ItineraryPrices',
  components: {
    ItineraryPricesWrapper,
  },
  data() {
    return {
      breadcrumbs: [
        { text: this.$t('menu.itinerary.title'), to: '', disabled: true },
        { text: this.$t(`breadcrumbs.${this.$route.name}`), to: this.$route.path },
      ],
      localItineraryPrice: null,
      selectedPriceIntervalIndex: 0,
      localDayProgram: [],
      dayProgramCreated: false,
    };
  },
  created() {
    this.getCarriers();
    this.getTransits();
    const payload = { itineraryId: this.$route.params.id, domainId: this.$route.params.domainId };
    this.getItineraryPriceIntervals(payload);
    this.getItineraryDayProgram(payload.itineraryId);
  },
  computed: {
    ...mapState({
      transits: state => state.nonDynamicTransport.transits.items,
      carriers: state => state.nonDynamicTransport.carriers.items,
      itineraryPrices: state => state.itinerary.priceIntervals.items,
      itineraryPriceIntervalsLoading: state => state.itinerary.priceIntervals.loading,
      dayProgram: state => state.itinerary.pricesDayProgram.items,
      dayProgramLoading: state => state.itinerary.pricesDayProgram.loading,
    }),
  },
  watch: {
    dayProgram: {
      deep: true,
      handler(value) {
        this.localDayProgram = [...value];
      },
    },
  },
  methods: {
    ...mapActions({
      getCarriers: 'nonDynamicTransport/getCarriers',
      getTransits: 'nonDynamicTransport/getTransitsByType',
      getItineraryPriceIntervals: 'itinerary/getItineraryPriceIntervals',
      getItineraryDayProgram: 'itinerary/getItineraryDayProgram',
    }),
  },
};
</script>

<template>
  <div class="mt-3">
    <div class="text-xs-center">
      <v-progress-circular
        v-if="itineraryPriceIntervalsLoading || dayProgramLoading || !localDayProgram.length"
        color="primary"
        indeterminate
      />
    </div>
    <itinerary-prices-wrapper
      v-if="!itineraryPriceIntervalsLoading && !dayProgramLoading && localDayProgram.length"
      :itinerary-prices="itineraryPrices"
      :transits="transits"
      :carriers="carriers"
      :day-program="localDayProgram"
    />
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/itinerary/ItineraryPrices.vue